import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { antTheme } from './styles/theme.js';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { AppRoutes } from './routes/AppRoutes.jsx';
import { PageViewTracker } from './components/common/PageViewTracker.jsx';
import './index.css';

export function App() {
  return (
    <ConfigProvider theme={antTheme} locale={viVN}>
      <BrowserRouter>
        <AuthProvider>
          <PageViewTracker />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
        limit={3}
      />
    </ConfigProvider>
  );
}

export default App;
